import React from "react";
import ParticlesBg from "particles-bg";

class Bg extends React.Component {
  constructor() {
    super();
    this.state = {
      name: "React"
    };
  }

  render() {


    return (
      <div>

        <ParticlesBg color="#8cd7f3" num={30} type="cobweb" bg={true} />

      </div>
    )
  }
}
export default Bg;